<div class="section-profile">

    <!--<h2>Avatar</h2>
    <div class="avatar">
        <div class="container-image">
            <img src="/assets/img/image-profile.png" onerror="this.src='/assets/img/image-user-profile-not-found.png';" alt="Avatar por default" />
        </div>
        <input #inputFile type="file" style="display: none;" />
        <button mat-button class="button-primary" (click)="inputFile.click()">Cambiar avatar</button>
    </div>-->


    <!-- Información de Contacto -->
    <div *ngIf="currentUser" class="form-container contact-info">
        <div class="title">
            <h2>Información de contacto</h2>
            <!--<button mat-button (click)="isEditInfo = true">Editar</button>-->
        </div>


        <!-- El botón "Editar" tiene que sacar el "disabled" de cada input (de su sector) y sacar el "*ngIf" que oculta los botones de Guardar y Cancelar (de su sector) -->



        <div class="form-control">
            <div class="col-left">
                <label for="">Nombre completo <i matTooltip="Privado" class="fas fa-unlock-alt"></i></label>
            </div>
            <div class="col-right">
                <input type="text" [disabled]="!isEditInfo" [(ngModel)]="nameInput" />
                <mat-hint *ngIf="false">Identidad con la cual te veran los demás</mat-hint>
            </div>
        </div>

        <div class="form-control">
            <div class="col-left">
                <label for="">Número de teléfono <i matTooltip="Privado" class="fas fa-unlock-alt"></i></label>
            </div>
            <div class="col-right">
                <input type="text" [disabled]="!isEditInfo" [(ngModel)]="currentUser.phone" />
                <mat-hint *ngIf="false">asd</mat-hint>
            </div>
        </div>

        <!--<div class="form-control">
            <div class="col-left">
                <label for="">Dirección <i matTooltip="Privado" class="fas fa-unlock-alt"></i></label>
            </div>
            <div class="col-right">
                <input type="text" [disabled]="!isEditInfo" [(ngModel)]="currentUser.address" />
                <mat-hint *ngIf="false">Ingresar tu Dirección nos ayudara para mostrarte centros cercanos</mat-hint>
            </div>
        </div>-->

        <div class="form-control">
            <div class="col-left">
                <label for="">Dirección de correo electrónico <i matTooltip="Privado" class="fas fa-unlock-alt"></i></label>
            </div>
            <div class="col-right">
                <input type="email" value="" disabled [(ngModel)]="currentUser.email" />
                <mat-hint *ngIf="false">Identidad con la cual te veran los demás</mat-hint>
            </div>
        </div>

        <div class="form-control">
            <div class="col-left">
                <label for="">DNI <i matTooltip="Privado" class="fas fa-unlock-alt"></i></label>
            </div>
            <div class="col-right">
                <input type="text" [disabled]="!isEditInfo" [(ngModel)]="currentUser.document" />
                <mat-hint *ngIf="false">asd</mat-hint>
            </div>
        </div>

        <div *ngIf="isEditInfo" class="buttons">
            <button mat-button>Guardar</button>
            <button mat-button (click)="isEditInfo = false">Cancelar</button>
        </div>
    </div>


</div>
